'use client';

import type { JSX } from 'react';
import React from 'react';
import TemperatureElement from '@/components/climateTable/TemperatureElement';
import PrecipitationElement from '@/components/climateTable/PrecipitationElement';
import type { ApiClimateInfo } from '../../../api/model';
import useMonthLabels from '@/Hooks/useMonthLabels';

const MobileListItem = ({
  months,
  outerContainerMeasures,
  globalIdx
}: {
  months: ApiClimateInfo[];
  globalIdx: number;
  outerContainerMeasures: DOMRect | null;
}): JSX.Element => {
  const monthLabels = useMonthLabels(true);

  return (
    <div
      className="climate-table__swipe-item__container"
      style={{
        flex: outerContainerMeasures?.width ? `1 0 ${outerContainerMeasures.width}px` : '0'
      }}
    >
      {months.map((month: ApiClimateInfo, idx: number) => (
        <div key={month.name} className="climate-table__swipe-item">
          <div className="climate-table__month-header">{monthLabels[idx + globalIdx]}</div>
          <TemperatureElement minTemp={month.minTemp} maxTemp={month.maxTemp} />
          <PrecipitationElement precipitation={month.precipitation} />
        </div>
      ))}
    </div>
  );
};

export default MobileListItem;
